import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useCallback } from 'react';
import { useCampaignSchedulingSelector } from '../../../CampaignWorkflowTab/state/CampaignSettings/selectors/useCampaignSchedulingSelector';

export const useEndTime = () => {
  const { dispatch } = useCampaignEditorContext();

  const { endTime } = useCampaignSchedulingSelector() ?? {};
  const onEndTimeChanged = useCallback(
    (endTime: string) => dispatch({ type: 'SET_CAMPAIGN_END_TIME', payload: { endTime } }),
    [dispatch],
  );

  return {
    endTime,
    onEndTimeChanged,
  };
};
